import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraStatusDot } from '../ensigns/status-dot';
import { SpecraText } from '../ensigns/typography';
/** Expandable assistant reasoning/tool execution disclosure. */ export function SpecraToolRun({ children, className, summary, title, tone = 'success', ...props }) {
    return /*#__PURE__*/ _jsxs("details", {
        className: cn('rounded-md border border-border bg-muted/40', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsxs("summary", {
                className: "flex cursor-pointer list-none items-center gap-2 px-3 py-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraStatusDot, {
                        tone: tone
                    }),
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "font-medium",
                        size: "caption",
                        children: title
                    }),
                    summary ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "ml-auto",
                        size: "micro",
                        tone: "muted",
                        children: summary
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "border-t border-border px-3 py-2 text-[length:var(--fs-ui-caption)] text-muted-foreground",
                children: children
            })
        ]
    });
}
